(function() {
    'use strict';

    angular.module( APP_ID )
        .controller( 'PostgradAreasController', [ '$scope', '$controller', 'ContentSwitchingService', 'LoggerFactory', 'Utils', 'CONFIG', PostgradAreasController ]);

    /**
     * Downloads and prepares data for a specific postgraduate area.
     *
     * @param {ng.IScope} $scope
     * @param {ng.IControllerService} $controller
     * @param {ContentSwitchingService} ContentSwitchingService
     * @param {LoggerFactory} LoggerFactory
     * @param {Utils} Utils
     * @param {Object} CONFIG
     */
    function PostgradAreasController(
        $scope,
        $controller,

        ContentSwitchingService,
        LoggerFactory,
        Utils,

        CONFIG
    ){
        // Helper members.

        /** @type {angular.IController} */
        var vm = this;

        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'PostgradAreasController' );

        /** @type {BaseController} */
        var ctrl   = $controller( 'BasePageController', { 'vm': vm, 'logger': logger } );





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        function init(){
            overrideBaseController();
            ctrl.activate();
        };

        /** Run right after all the bindings are ready! */
        vm.$onInit = init;





        /* ===== CONTROLLER'S PUBLIC METHODS ================================ */
        /* ===== PRIVATE FUNCTIONS ========================================== */


        /**
         * Overrides parental's controller behaviour and attaches hooks.
         *
         * _Note: MUST BE called BEFORE the parental controller is activated!_
         */
        function overrideBaseController() {
            ctrl.contentRequestParams = {
                viewUrl: vm.$transition$.params()[ CONFIG.PARAMS.POSTGRAD_AREA_ID ],
                urlPath: CONFIG.API.CMS.PATHS.POSTGRAD_AREAS
            };

            ctrl.requiredContentAttributes.push( 'pages' );
            ctrl.preProcessResponse  = ctrl.prepareSubpagesFromResponse;
            ctrl.postProcessResponse = exposeDataWhereNeeded;
        }


        /**
         * Enhances content by adding extra data or references that can be
         * later used in underlying components.
         */
        function exposeDataWhereNeeded() {
            // Expose indicator if 'PhD' block does exist or not in any of available tabs
            Utils.addPhdBlockMetaIfExists( vm.content );

            saveInfoToCookie();
        }


        /**
         * Saves information about current study areas and selected major(s)
         * into a cookie, if it was already created by the `ContentSwitchingService`.
         */
        function saveInfoToCookie() {
            var lastVisitedPage = ContentSwitchingService.userSettings.lastVisitedPage;

            if ( !lastVisitedPage.hasOwnProperty( 'postgradArea' ) ) lastVisitedPage[ 'postgradArea' ] = {};

            lastVisitedPage.postgradArea[ 'webPath' ] = vm.metadata.id;

            // Save updated user information to the cookies!
            if ( ContentSwitchingService.isCookieAvailable() ) ContentSwitchingService.saveSettingsToCookie();
        }
    }
})();
